console.log("CUSTOM BUILDER JS LOADED");

// =========================
// THREAD COLOURS
// =========================

const THREAD_COLORS = {
  "001": "#4A4A47",
  "002": "#442014",
  "003": "#090B0A",

  "004": "#2C9E97",
  "005": "#326F5F",
  "006": "#006400",
  "007": "#004D19",

  "008": "#EFB7C4",
  "009": "#CD606F",
  "010": "#BF3B6D",
  "011": "#D3003F",
  "012": "#B10A1A",
  "013": "#D27A43",
  "014": "#F4D000",

  "015": "#94C4DC",
  "016": "#14679F",
  "017": "#003691",
  "018": "#0D5C70",
  "019": "#2E166A",
  "020": "#5B507A",
  "021": "#643980",
  "022": "#B7A7D3"
};

document.addEventListener("DOMContentLoaded", function () {

const steps = document.querySelectorAll(".step-card");

if (!steps.length) return;

// =========================
// DOM ELEMENTS
// =========================


const selectedThreadNumber = document.getElementById("selectedThreadNumber");
  const selectedThreadDot = document.getElementById("selectedThreadDot");
  const builderPrice = document.getElementById("builderPrice");

  function validateBuilder() {

  if (!state.style) {
    builderError.textContent = "Please select a sock style.";
    return false;
  }

  if (!state.thread) {
    builderError.textContent = "Please choose a thread colour.";
    return false;
  }

  if (!state.font) {
    builderError.textContent = "Please select a font.";
    return false;
  }

  if (!state.line1.trim() && !state.line2.trim()) {
    builderError.textContent = "Please enter your embroidery text.";
    return false;
  }

  builderError.textContent = "";
  return true;

  }

  function updateLanguageAndPrice() {

    if (!builderPrice) return;

    const text = `${state.line1} ${state.line2}`;

    const hasChinese = /[\u3400-\u9FFF]/.test(text);

    state.language = hasChinese ? "chinese" : "english";

    builderPrice.textContent = hasChinese
      ? "HK$220"
      : "HK$200";
  }


const guideToggle = document.querySelector(".builder-card__toggle");

const embLine1 = document.getElementById("embLine1");
const embLine2 = document.getElementById("embLine2");

const VARIANTS = {
  english: 48700584886372,
  chinese: 48700584919140
};

const builderError = document.getElementById("builderError");


// =========================
// GLOBAL STATE
// =========================

const state = {
  style: "Toe Socks",
  thread: "",
  font: "great-vibes",
  line1: "",
  line2: "",
  language: "english",
  packaging: "standard",
  recipient: ""
};

// =========================
// STEP CONTROL
// =========================

function openStep(stepNumber) {

  let activeStep = null;

  steps.forEach(step => {

    const body = step.querySelector(".step-card__body");

    if (parseInt(step.dataset.step) === stepNumber) {

      activeStep = step;

      step.classList.add("is-open");
      body.style.display = "block";

    } else {

      step.classList.remove("is-open");
      body.style.display = "none";

    }

  });

  // Mobile only smooth scroll
  if (
    window.matchMedia("(max-width: 990px)").matches &&
    activeStep
  ) {

    setTimeout(() => {

      const container = document.querySelector(".sock-builder__right");
      const sticky = document.querySelector(".sock-builder__left");

      if (!container || !sticky) return;

      const currentScroll = container.scrollTop;

      const stepTop =
          activeStep.getBoundingClientRect().top;

      const containerTop =
          container.getBoundingClientRect().top;

      const target =
          currentScroll + (stepTop - containerTop) - 20;

      container.scrollTo({
          top: target,
          behavior: "smooth"
      });

    }, 150);

  }

}

function collapseStep(step) {

  step.classList.remove("is-open");

  const body = step.querySelector(".step-card__body");

  if (body) {
    body.style.display = "none";
  }

}

openStep(1);


// =========================
// UPDATE PREVIEW
// =========================

function updatePreview() {

  // Embroidery text
  if (embLine1) embLine1.textContent = state.line1;
 

  if (embLine2) embLine2.textContent = state.line2;
 

  // Thread colour
  const colour = THREAD_COLORS[state.thread] || "#222";

  if (embLine1) embLine1.style.color = colour;
  

  if (embLine2) embLine2.style.color = colour;
  

  // Font style
  const FONT_MAP = {
    "great-vibes": "'Great Vibes', cursive",
    "cormorant": "'Cormorant Garamond', serif",
    "playfair": "'Playfair Display', serif",
    "marcellus": "'Marcellus', serif",
    "montserrat": "'Montserrat', sans-serif",
    "dancing": "'Dancing Script', cursive",
    "noto-serif-tc": "'Noto Serif TC', serif",
  };

  const fontFamily = FONT_MAP[state.font] || "'Great Vibes', cursive";

 if (embLine1) embLine1.style.fontFamily = fontFamily;


 if (embLine2) embLine2.style.fontFamily = fontFamily;


  // Selected thread display
  if (selectedThreadNumber) {
    selectedThreadNumber.textContent = state.thread || "—";
  }

  if (selectedThreadDot) {
    selectedThreadDot.style.backgroundColor = colour;
  }

  const threadSummary = document.getElementById("threadSummary");

  if (threadSummary) {
    threadSummary.textContent = state.thread
      ? `Selected: ${state.thread}`
      : "Selected: —";
  }

}
// =========================
// COLOUR THE THREAD SWATCHES
// =========================

document.querySelectorAll(".thread-option").forEach(option => {

  const number = option.dataset.thread;
  const swatch = option.querySelector(".thread-swatch");

  if (!swatch) return;

  swatch.style.backgroundColor = THREAD_COLORS[number] || "#ddd";

});

// =========================
// STEP HEADER TOGGLE
// =========================

steps.forEach(step => {

  const header = step.querySelector(".step-card__header");

  if (!header) return;

  header.addEventListener("click", () => {

    if (step.classList.contains("is-open")) {
      collapseStep(step);
    } else {
      openStep(Number(step.dataset.step));
    }

  });

});

// =========================
// OPTION SELECT (STEP 1 & 5)
// =========================

document.querySelectorAll(".option-card").forEach(option => {

  option.addEventListener("click", function () {

    const step = this.closest(".step-card");
    const stepId = Number(step.dataset.step);

    step.querySelectorAll(".option-card")
      .forEach(o => o.classList.remove("is-selected"));

    this.classList.add("is-selected");

    // STEP 1
    if (stepId === 1) {

      state.style = this.textContent.trim();

      collapseStep(step);
      openStep(2);

      updatePreview();
      return;

    }

    // STEP 5
    if (stepId === 5) {

      state.packaging = this.dataset.packaging;

      console.log("Packaging:", state.packaging);

      updatePreview();
      return;

    }

  });

});

// =========================
// THREAD SELECTOR (STEP 2)
// =========================

document.querySelectorAll(".thread-option").forEach(option => {

  option.addEventListener("click", function () {

    document.querySelectorAll(".thread-option")
      .forEach(o => o.classList.remove("is-selected"));

    this.classList.add("is-selected");

    state.thread = this.dataset.thread;

    updatePreview();

    const step = this.closest(".step-card");

    collapseStep(step);

    openStep(3);

  });

});
// =========================
// FONT SELECTOR (STEP 3)
// =========================

// =========================
// FONT SELECTOR (STEP 3)
// =========================

document.querySelectorAll(".font-option").forEach(option => {

  option.addEventListener("click", function () {

    document.querySelectorAll(".font-option")
      .forEach(o => o.classList.remove("is-selected"));

    this.classList.add("is-selected");

    state.font = this.dataset.font;

    updatePreview();

    collapseStep(this.closest(".step-card"));
    openStep(4);

  });

});

// =========================
// PERSONALISATION INPUTS
// =========================

if (line1Input) {

  line1Input.addEventListener("input", function () {

    state.line1 = this.value;

    updateLanguageAndPrice();
    updatePreview();

  });

}

if (line2Input) {

  line2Input.addEventListener("input", function () {

    state.line2 = this.value;

    updateLanguageAndPrice();
    updatePreview();

  });

}

// =========================
// GIFT RECIPIENT
// =========================

const recipientInput = document.getElementById("recipientInput");

if (recipientInput) {

  recipientInput.addEventListener("input", function () {

    state.recipient = this.value;

    updatePreview();

  });

}
// =========================
// THREAD GUIDE ACCORDION
// =========================

if (guideToggle) {

  guideToggle.addEventListener("click", function () {

    const card = this.closest(".builder-card");
    const isOpen = card.classList.toggle("is-open");

    this.setAttribute("aria-expanded", isOpen);

  });

}

// =========================
// INITIALISE
// =========================

const addToCartBtn = document.querySelector(".add-to-cart__btn");

if (addToCartBtn) {

  addToCartBtn.addEventListener("click", async function () {

    const originalButtonText = addToCartBtn.textContent;

    if (!validateBuilder()) return;

    const variantId =
      state.language === "chinese"
        ? VARIANTS.chinese
        : VARIANTS.english;

    try {

      addToCartBtn.disabled = true;
      addToCartBtn.textContent = "Adding...";

      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: {
            "Style": state.style,
            "Thread Colour": state.thread,
            "Font": state.font,
            "Line 1": state.line1,
            "Line 2": state.line2,
            "Packaging": state.packaging,
            "Recipient": state.recipient
          }
        })
      });

      if (!response.ok) {
        throw new Error("Failed to add item.");
      }

      // Open cart page for now
      document.dispatchEvent(new CustomEvent("cart:refresh"));
      const cartDrawer = document.querySelector("cart-drawer");

      if (cartDrawer && typeof cartDrawer.showDialog === "function") {
        cartDrawer.showDialog();
      } else {
        document.documentElement.dispatchEvent(new CustomEvent("cart:open"));
      }

    } catch (error) {

      builderError.textContent =
        "Something went wrong. Please try again.";

    } finally {

      addToCartBtn.disabled = false;
      addToCartBtn.textContent =
        "Add to Cart";

    }

  });

}

updateLanguageAndPrice();
updatePreview();

});